import { useRef, useState } from "react";
import { StarIcon } from "@heroicons/react/solid";
import classNames from "lib/classNames";
// import useIsLoggedIn from "hooks/user/useIsLoggedIn";

export interface UserBookRatingProps {
  rating?: number;
  onRatingChanged?: any;
  onRatingHoverChange?: any;
  size?: number;
}

export default function InteractiveStars(props: UserBookRatingProps) {
  const {
    rating = null,
    onRatingChanged,
    onRatingHoverChange,
    size = 6,
  } = props;
  const [hoverRating, setHoverRating] = useState(0);
  // const isLoggedIn = useIsLoggedIn();
  const halfSize = size / 2;

  // let party;
  // if (
  //   isLoggedIn &&
  //   onRatingChanged &&
  //   typeof window !== "undefined" &&
  //   typeof document !== "undefined"
  // ) {
  //   // eslint-disable-next-line global-require
  //   party = require("party-js");
  // }
  const starsRef = useRef();

  const starClicked = (newRating) => {
    // if (party && newRating === 5) {
    //   party.default.sparkles(starsRef.current, {
    //     count: party.default.variation.range(20, 30),
    //     speed: party.default.variation.range(50, 150),
    //     size: party.default.variation.range(0.5, 1.5),
    //   });
    // }
    if (onRatingChanged) {
      onRatingChanged(newRating);
    }
    if (onRatingHoverChange) {
      onRatingHoverChange(newRating);
    }
  };

  const onHover = (stars) => {
    if (onRatingChanged) {
      setHoverRating(stars);
    }
    if (onRatingHoverChange) {
      onRatingHoverChange(stars);
    }
  };

  return (
    <div className="relative flex flex-row" ref={starsRef}>
      {[0, 1, 2, 3, 4].map((star) => (
        <div
          key={`star-${star}`}
          className={classNames(
            `relative h-${size} w-${size}`,
            onRatingChanged ? "hover:cursor" : ""
          )}
        >
          <StarIcon
            onMouseOver={() => onHover(star + 1)}
            onMouseOut={() => (onRatingChanged ? onHover(null) : null)}
            onMouseDown={() => (onRatingChanged ? starClicked(star + 1) : null)}
            className={classNames(
              `absolute h-${size} w-${size}`,
              hoverRating >= star + 1 ? "text-yellow-300" : "",
              !hoverRating && rating >= star + 1 ? "text-yellow-400" : "",
              !hoverRating && rating < star + 1 ? "text-gray-400" : ""
            )}
          />
          <span className={`absolute h-${size} w-${halfSize} overflow-hidden`}>
            <StarIcon
              onMouseOver={() => onHover(star + 0.5)}
              onMouseOut={() => (onRatingChanged ? onHover(null) : null)}
              onMouseDown={() =>
                onRatingChanged ? starClicked(star + 0.5) : null
              }
              className={classNames(
                `absolute h-${size} w-${size}`,
                hoverRating >= star + 0.5 ? "text-yellow-300" : "",
                !hoverRating && rating >= star + 0.5 ? "text-yellow-400" : "",
                !hoverRating && rating < star + 0.5 ? "text-gray-400" : ""
              )}
            />
          </span>
        </div>
      ))}
    </div>
  );
}
